
(function () {
  function init() {
    var details = document.querySelector('#Details-menu-drawer-container');
    var summary = details && details.querySelector('summary');
    if (!details || !summary) return;

    // Remove the on:click binding so the theme's delegate handler cannot interfere
    summary.removeAttribute('on:click');

    summary.addEventListener('click', function (e) {
      e.preventDefault(); // stop native <details> toggle
      var open = details.classList.contains('menu-open');
      if (open) {
        details.classList.remove('menu-open');
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      } else {
        details.classList.add('menu-open');
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
